/* eslint-disable max-lines */
/* eslint-disable radix */
/* eslint-disable xss/no-mixed-html */
/* eslint-disable vars-on-top */
/* eslint-disable id-match */
/* eslint-disable xss/no-location-href-assign */
/* Marketing Materials Story */
$(document).ready(function() {
  var buid = $('.ph-firstBuid').val(),
      dateVal = new Date(),
      monthVal = dateVal.getMonth(),
      selBUName = '#buName',
      selSalemonth = '#salesMonth',
      salesPanel = '#salesgraphPanel',
      detailMsg = '.ph-detailmag';

  function getFileDetails(fileURL, linkUrl) {
    var filedata = [];

    if (fileURL) {
      filedata[0] = fileURL;
      filedata[1] = '_self';
      filedata[2] = 'ph-marketmatdwnldlogo';
    } else {
      filedata[0] = linkUrl;
      filedata[1] = '_blank';
      filedata[2] = 'ph-marketmatextrnlogo';
    }

    return filedata;
  }

  function createAnchorElement(fileDet) {
    var anchorEle = '';

    anchorEle = '<a class="ph-marketmatlink' + fileDet[1] + '" href="' + fileDet[0] + '" target="' + fileDet[1] + '">' +
    '<div class="ph-d-row ph-ml-sm-0 ' + fileDet[2] + '">' +
    '</div></a>';

    if (fileDet[1] === '_self') {
      anchorEle = '<span class="clear-dates ph-marketmatlink' + fileDet[1] + '" data-url="' + fileDet[0] + '">' +
      '<div class="ph-d-row ph-ml-sm-0 ' + fileDet[2] + '">' +
      '</div></span>';
    }

    return anchorEle;
  }

  function showLoadButton(result) {
    if (result.length > 10) {
      $('.ph-dashmarketbtn').removeClass('hidden');
    }
  }

  function getExtendedSalesData(selBuid, selMonth) {
    $.ajax({
      url: ACC.config.encodedContextPath + '/salesdata/growth/' + selBuid + '/' + selMonth,
      type: 'GET',
      dataType: 'html',
      success: function(response) {
        $(salesPanel).html(response);
        $('.ph-salesprogressbar').hover(function(event) {
          var leftVal = event.pageX - $(this).offset().left + 10;

          $(this).next(detailMsg).css({
            left: leftVal
          }).show();
        }, function() {
          $(detailMsg).hide();
        });
      },
      error: function() {
        ACC.common.refreshScreenReaderBuffer();
      }
    });
  }

  if ($('.ph-market-material-sec').length > 0) {
    var marketContent = '',
        displayCont = '',
        materialRow = '',
        anchorElement = '',
        closingDiv = '</div></div>';

    $.ajax({
      url: ACC.config.encodedContextPath + '/dashboard/getMarketingMaterials',
      type: 'GET',
      datatype: 'json',
      success: function(result) {
        showLoadButton(result);
        $('.ph-mat-count').val(result.length);

        for (var materialindex = 0; materialindex < result.length; materialindex = materialindex + 1) {
          materialRow = result[materialindex];
          $('.ph-mark-head').removeClass('hidden');

          if ((materialindex + 1) > 10) {
            displayCont = 'ph-d-none';
          }

          var fileDet = getFileDetails(materialRow.marketingMaterialFileUrl, materialRow.externalLinkUrl);

          anchorElement = createAnchorElement(fileDet);

          marketContent = marketContent + '<div class="' + displayCont + ' ph-col-12 ph-mb-1 ph-marketmattab_' + (materialindex + 1) +
' ph-market-material-sec" ><div class="ph-p-sm-2 ph-p-1 ph-d-flex ph-bgwhite"><div class="ph-d-sm-flex ph-d-row ph-marketmattitlediv">' +
'<div class="ph-w-30 ph-mr-sm-4 ph-d-row ph-profilebox16font ph-font-weight-bold ph-marketmattitleres" >' + materialRow.title +
'</div><div class="ph-w-60 ph-d-row ph-mr-sm-4 ph-font14px ph-marketmatresdesc ">' + materialRow.description + closingDiv +
anchorElement + closingDiv;
        }

        $('.ph-load-mark-mat').html(marketContent);
        $('.ph-load-mark-mat').append('<a href="" id="ph-dwnld_pdf"></a>');
      }

    });
  }

  if ($('.ph-firstBuid').length > 0) {
    getExtendedSalesData(buid, monthVal);
  }

  $(document).on('change', '.ph-selOptSale', function() {
    var selBUNameVal = $(selBUName).val(),
        selSalemonthVal = $(selSalemonth).val();

    getExtendedSalesData(selBUNameVal, selSalemonthVal);
  });
});
$(document).ready(function() {
  var basepath = window.location.protocol + '//' + window.location.host,
      relativePathUrl = ACC.config.encodedContextPath + '/orderhistory',
      relativePath = ACC.config.encodedContextPath + '/my-account/orders',
      newOrderHistoryToggle = $('.ph-isNewOrderHistory').val();

  function createUserEventObj(url, desc) {
    return {
      url: url,
      description: desc,
      trigger: 'linkCategory.clickMarketing',
      compname: 'linkMarketing'
    };
  }

  function createUserEventObjs(url, desc, trigger, compname) {
    return {
      url: url,
      description: desc,
      trigger: trigger,
      compname: compname
    };
  }

  $(document).on('click', '.ph-blueoutlineloadbtn', function() {
    var clickCount = parseInt($('.ph-display-click').val()),
        count = clickCount * 10,
        maxvalue = $('.ph-mat-count').val(),
        ind = 0;

    for (ind = count; ind <= count + 10; ind = ind + 1) {
      $(String('.ph-marketmattab_' + ind)).removeClass('ph-d-none');

      if (ind === parseInt(maxvalue)) {
        $(this).addClass('ph-d-none');
      }
    }

    clickCount = clickCount + 1;
    $('.ph-display-click').val(clickCount);
    window.scrollBy({
      top: 1,
      left: 1,
      behavior: 'smooth'
    });
  });
  $(document).on('click', '.ph-marketmatlink_self', function() {
    var url = $(this).attr('data-url'),
        title = $(this).parent().find('.ph-marketmattitleres').text(),
        desc = $(this).parent().find('.ph-marketmatresdesc p').text(),
        userEventObj = '';

    desc = title + '-' + desc;
    userEventObj = createUserEventObj(url, desc);
    ACC.googleanalytics.gaEventsForLinks(userEventObj);

    $('#ph-dwnld_pdf').attr('href', url);
    setTimeout(function() {
      window.location = $('#ph-dwnld_pdf').attr('href');
    }, 1000);
  });
  $(document).on('click', '.ph-marketmatlink_blank', function() {
    var url = $(this).attr('href'),
        title = $(this).parent().find('.ph-marketmattitleres').text(),
        desc = $(this).parent().find('.ph-marketmatresdesc p').text(),
        userEventObj = '';

    desc = title + '-' + desc;
    userEventObj = createUserEventObj(url, desc);
    ACC.googleanalytics.gaEventsForLinks(userEventObj);
  });
  $(document).on('click', '.ph-mydashboard_ga', function() {
    var url = $(this).attr('href'),
        desc = $(this).text(),
        userEventObj = {
          url: url,
          description: desc,
          trigger: 'linkCategory.clickMyDashboard',
          compname: 'linkCategory'
        };

    ACC.googleanalytics.gaEventsForLinks(userEventObj);
  });
  $(document).on('click', '.ph-order-overview-sec .ph-oov-allorders-text', function() {
    var url = basepath + relativePath,
        desc = $(this).text().trim(),
        trigger = 'linkCategory.clickAllOrders',
        compname = 'linkAllOrders',
        userEventObj = '';

    if (newOrderHistoryToggle === 'true') {
      url = basepath + relativePathUrl;
    }

    userEventObj = createUserEventObjs(url, desc, trigger, compname);
    ACC.googleanalytics.gaEventsForLinks(userEventObj);
  });

  $(document).on('click', '.ph-order-overview-sec .ph-oovtopsec', function() {
    var parentVal = $(this).find('.ph-oovsec1orderno'),
        orderCode = parentVal.find('.ph-font-weight-bold').text(),
        relativePathOld = ACC.config.encodedContextPath + '/my-account/order/' + orderCode,
        url = basepath + relativePathOld,
        desc = String(parentVal.find('.ph-oovsec1ordernotst').text().trim()) + ' ' + orderCode,
        trigger = 'linkCategory.clickOrderDetails',
        compname = 'linkOrderDetails',
        userEventObj = '';

    if (newOrderHistoryToggle === 'true') {
      url = basepath + relativePathUrl;
    }

    userEventObj = createUserEventObjs(url, desc, trigger, compname);
    ACC.googleanalytics.gaEventsForLinks(userEventObj);
  });
  $(document).on('click', '.ph-oovajaxbtn', function() {
    var clickCountoov = parseInt($('.ph-displayoov-click').val()),
        count = clickCountoov * 5,
        maxvalue = $('.ph-oov-count').val(),
        ind = 0,
        topx = 1,
        boty = 1,
        url = '',
        desc = $(this).text().trim(),
        trigger = 'linkCategory.clickLoadMore',
        compname = 'linkLoadMore',
        userEventObj = '';

    if (clickCountoov > 1 && newOrderHistoryToggle === 'true') {
      url = basepath + relativePathUrl;
      userEventObj = createUserEventObjs(url, desc, trigger, compname);
      ACC.googleanalytics.gaEventsForLinks(userEventObj);
      window.location.href = url;
    } else if (clickCountoov > 1 && newOrderHistoryToggle === 'false') {
      url = basepath + relativePath;
      userEventObj = createUserEventObjs(url, desc, trigger, compname);
      ACC.googleanalytics.gaEventsForLinks(userEventObj);
      window.location.href = url;
    } else {
      for (ind = count; ind <= count + 5; ind = ind + 1) {
        $(String('.ph-oovtab_' + ind)).removeClass('ph-d-none');

        if (ind === parseInt(maxvalue)) {
          $(this).addClass('ph-d-none');
        }
      }

      url = window.location.href;
      userEventObj = createUserEventObjs(url, desc, trigger, compname);
      ACC.googleanalytics.gaEventsForLinks(userEventObj);
    }

    clickCountoov = clickCountoov + 1;
    $('.ph-displayoov-click').val(clickCountoov);
    window.scrollBy({
      top: topx,
      left: boty,
      behavior: 'smooth'
    });
  });
  $(document).on('click', '.ph-salesrep-btn', function() {
    $.ajax({
      url: ACC.config.encodedContextPath + '/salesdata/download',
      type: 'POST',
      datatype: 'json',
      success: function() {
        $.colorbox({
          width: '450px',
          maxWidth: '90%',
          html: $('.ph-pbreportgeneration').html(),
          overlayClose: false,
          onComplete: function() {
            $('.ph-pbgeneratereportredirect').attr('href', ACC.config.encodedContextPath + '/reports?reporttrigger');
          },
          onClosed: function() {
            ACC.common.refreshScreenReaderBuffer();
          }
        });
      },
      error: function() {
        ACC.common.refreshScreenReaderBuffer();
      }
    });
  });
  $(document).on('click', '.ph-salesgraphdetail-bar', function() {
    var collapsedCls = 'ph-collapsed';

    if ($(this).hasClass(collapsedCls)) {
      $('.ph-salesgraph_foldout').slideDown('slow');
      $('.ph-salesgraph-close').show();
      $(this).removeClass(collapsedCls);
      $(this).removeClass('ph-icon-arrow-down');
      $(this).addClass('ph-expand');
    } else {
      $('.ph-salesgraph_foldout').hide();
      $('.ph-salesgraph-close').hide();
      $(this).addClass(collapsedCls);
      $(this).addClass('ph-icon-arrow-down');
      $(this).removeClass('ph-expand');
    }
  });
});

/* For Order Overview story */

$(document).ready(function() {
  var content = '',
      oovRow = '',
      displayContoov = '',
      ordernumberdash = $('.ph-ordernumberdash').val(),
      adrurl = '';

  function generateOrderHistoryUrl(orderCode) {
    var url = ACC.config.encodedContextPath + '/my-account/order/' + orderCode,
        newOrderHistory = $('.ph-isNewOrderHistory').val();

    if (newOrderHistory === 'true') {
      url = ACC.config.encodedContextPath + '/orderhistory?orderCode=' + orderCode;
    }

    return url;
  }

  if ($('.ph-order-overview-sec').length > 0) {
    $('.ph-spinnerinterstitial').removeClass('hidden');
    $.ajax({
      url: ACC.config.encodedContextPath + '/dashboard/accountOrders',
      type: 'GET',
      datatype: 'json',
      /* eslint-disable max-statements */
      /* eslint-disable complexity */
      success: function(result) {
        $('.ph-spinnerinterstitial').addClass('hidden');

        var orderList = result.orderHistoryList,
            orderCodeId = 0;

        if (orderList.length > 5) {
          $('.ph-dashorderbtn').removeClass('hidden');
        }

        $('.ph-oov-count').val(orderList.length);

        if (result.isSapOrders === true && parseInt(result.orderHistoryList.length, 10) > 0) {
          $('.ph-homePage-advancedSearchButton').addClass('hidden');
        }

        for (var oovindex = 0; oovindex < orderList.length; oovindex = oovindex + 1) {
          $('.ph-oov-header').removeClass('hidden');
          $('.ph-hp_recentorders').removeClass('hidden');
          $('.ph-order-main-sec').removeClass('hidden');
          oovRow = orderList[oovindex];

          if (oovRow.code === '' || oovRow.code === null) {
            orderCodeId = oovRow.localHybrisOrderCode;
          } else {
            orderCodeId = oovRow.code;
          }

          var indicatorColor = ACC.neworder.indicatorColorSelector(oovRow.finalOrderStatus);

          if (((oovindex + 1) > 5) || ((oovindex + 1) > 3 && ($('.template-pages-layout-landingLayout1Page').length > 0))) {
            displayContoov = 'ph-d-none';
          }

          adrurl = generateOrderHistoryUrl(orderCodeId);

          content = content + '<a class="ph-dashblackfont ph-font14px" href="' + adrurl + '"><div class="' + displayContoov +
                          ' ph-col-12 ph-mb-1 ph-oovtab_' + (oovindex + 1) + '">' +
                '<div class="ph-w-90 ph-bgwhite">' +
                '<div class="ph-d-md-flex ph-d-flex-row ph-oovtopsec">' +
                '<div class="ph-d-md-flex ph-d-flex-row ph-justify-content-around ph-oovsec1">' +
                '<div class="ph-oovsec1orderno"><span class="ph-oovsec1ordernotst">' + ordernumberdash + ':&nbsp;&nbsp;</span>' +
                '<span class="ph-font-weight-bold">' + oovRow.code + '</span></div>' +
                '<div class="ph-oovsec1date">' + oovRow.orderCreationDate + '</div>' +
                '</div>' +
                '<div class="ph-d-md-flex ph-d-flex-row ph-justify-content-around  ph-oovsec2">' +
                '<div class="ph-oovsec2pono"><span>PO#:&nbsp;&nbsp;</span>' + oovRow.purchaseOrderNumber + '</div>' +
                '<div class="ph-oovsec2ordertype"><span>' + oovRow.documentName + '&nbsp;(' +
                oovRow.documentType + ')</span></div>' +
                '<div class="ph-oovsecorderstatus ph-d-flex ph-flex-row"><svg height="16" width="16">' +
                '<circle cx="8" cy="10" r="4" fill="' + indicatorColor + '" /></svg>&nbsp;&nbsp;<div class="ph-oovstatustxt">' +
                oovRow.localizedFinalOrderStatus + '</div></div>' +
                '</div>' +
                '</div>' +
                '</div>' +
                '</div></a>';
        }


        $('.ph-load-order-overview').html(content);

        if ($('.ph-dashblackfont').length === 0 && window.location.href.endsWith('/dashboardDetails')) {
          $('.ph-homePage-advancedSearchButton').addClass('hidden');
        }
      },
      /* eslint-enable max-statements */
      /* eslint-enable complexity */
      error: function() {
        $('.ph-spinnerinterstitial').addClass('hidden');
      }
    });
  }
});

/* Credit Component Story */
$(document).ready(function() {
  if ($('.ph-creditcomponent').length > 0) {
    $.ajax({
      url: ACC.config.encodedContextPath + '/dashboard/creditInfo',
      type: 'GET',
      datatype: 'json',
      success: function(result) {
        $('.ph-creditlimitval').html(result.header.creditLimit.formattedValue);
        $('.ph-availamtval').html(result.header.availableAmount.formattedValue);
        $('.ph-creditpercentvalue').html(result.header.creditLimitPercentage);

        var percentval = result.header.creditLimitPercentage;

        $('.ph-creditbarbold').css('width', percentval + '%');
      }
    });
  }
});

$(document).ready(function() {
  var uri = window.location.href,
      orderBlockToggleEnabled = $('#ph-orderBlockStatus').val(),
      isOrderBlockMsgHasBeenDisplayedExists = localStorage.getItem('orderBlockMsgHasBeenDisplayed'),
      creditBlockToggleEnabled = $('#ph-creditBlockStatus').val(),
      isCreditBlockMsgHasBeenDisplayedExists = localStorage.getItem('creditBlockMsgHasBeenDisplayed'),
      popupWidth = '70%';

  if (orderBlockToggleEnabled === 'true' && isOrderBlockMsgHasBeenDisplayedExists === null) {
    $.colorbox({
      maxWidth: '630px',
      width: popupWidth,
      height: 'auto',
      clickOutside: true,
      html: $('#ph-homePageOrderBlock').html(),
      onLoad: function() {
        $('#cboxClose').remove();
      },
      onClosed: function() {
        ACC.common.refreshScreenReaderBuffer();
      }
    });
    localStorage.setItem('orderBlockMsgHasBeenDisplayed', 'true');
  }

  if (orderBlockToggleEnabled !== 'true' && creditBlockToggleEnabled === 'true' &&
isCreditBlockMsgHasBeenDisplayedExists === null) {
    $.colorbox({
      maxWidth: '630px',
      width: popupWidth,
      height: 'auto',
      clickOutside: true,
      html: $('#ph-homePageCreditBlock').html(),
      onLoad: function() {
        $('#cboxClose').remove();
      },
      onClosed: function() {
        ACC.common.refreshScreenReaderBuffer();
      }
    });
    localStorage.setItem('creditBlockMsgHasBeenDisplayed', 'true');
  }

  if (uri.endsWith('/login')) {
    localStorage.removeItem('orderBlockMsgHasBeenDisplayed');
    localStorage.removeItem('creditBlockMsgHasBeenDisplayed');
  }
});


/* eslint-enable radix */
/* eslint-enable xss/no-mixed-html */
/* eslint-enable vars-on-top */
/* eslint-enable id-match */
/* eslint-enable xss/no-location-href-assign */
/* eslint-enable max-lines */
